// @flow

import qs from 'qs'
import parse from 'parse-link-header'
import { push } from 'connected-react-router'
import {
  getApiBaseUrlWithOrg,
  checkHttpStatus,
  getApiHeaders
} from '../utils/api'
import type { APIError } from '../types'
import type { Action } from '../types/actions/myartifacts'
import { getErrorAction } from '../utils/actions'

export const CLEAR_MY_ARTIFACTS = 'CLEAR_MY_ARTIFACTS'
export const SET_MY_ARTIFACTS_COURSE_FILTER = 'SET_MY_ARTIFACTS_COURSE_FILTER'
export const FETCH_MY_ARTIFACTS_REQUEST = 'FETCH_MY_ARTIFACTS_REQUEST'
export const FETCH_MY_ARTIFACTS_SUCCESS = 'FETCH_MY_ARTIFACTS_SUCCESS'
export const FETCH_MY_ARTIFACTS_FAILURE = 'FETCH_MY_ARTIFACTS_FAILURE'

export function clearMyArtifacts() {
  return {
    type: CLEAR_MY_ARTIFACTS
  }
}

export function setMyArtifactsCourseFilter(courseSectionId: number) {
  return {
    type: SET_MY_ARTIFACTS_COURSE_FILTER,
    courseSectionId: courseSectionId
  }
}

export function fetchMyArtifactsSuccess(
  response: Array<Object>,
  linkHeaders: Object
): Action {
  return {
    type: FETCH_MY_ARTIFACTS_SUCCESS,
    artifacts: response,
    nextUrl: linkHeaders && linkHeaders.next ? linkHeaders.next.url : null,
    urlsDone: linkHeaders && linkHeaders.next ? false : true
  }
}

export function fetchMyArtifactsFailure(error: APIError): Action {
  return getErrorAction(FETCH_MY_ARTIFACTS_FAILURE, error)
}

export function fetchMyArtifactsRequest(): Action {
  return {
    type: FETCH_MY_ARTIFACTS_REQUEST
  }
}

export function fetchMyArtifacts(courseSectionId, useNextUrl, masterCourseFilterId): Function {
  return async (dispatch, getState) => {
    const state = getState()

    dispatch(fetchMyArtifactsRequest())

    try {
      const params =
        courseSectionId > -1
          ? qs.stringify({
              q: {
                course_section_id_eq: courseSectionId
              }
            })
          : null

      const url = masterCourseFilterId !== -1
        ? `${getApiBaseUrlWithOrg(state.organization.orgId)}/user/master_courses/${masterCourseFilterId}/work_item_quests`
        : useNextUrl && state.myartifacts.nextUrl
          ? state.myartifacts.nextUrl
          : `${getApiBaseUrlWithOrg(state.organization.orgId)}/user/work_item_quests?per_page=10&page=${1}&${params || ''}`


      const response = checkHttpStatus(
        await fetch(url, {
          method: 'GET',
          headers: getApiHeaders(state)
        })
      )

      const data = await response.json()
      
      dispatch(
        fetchMyArtifactsSuccess(data, parse(response.headers.get('Link')))
      )
    } catch (error) {
      dispatch(fetchMyArtifactsFailure(error))

      if (error.response.status === 404) {
        dispatch(push('/notfound'))
      }

      if (error.response.status === 500) {
        dispatch(push('/error'))
      }
    }
  }
}
